import { render, staticRenderFns } from "./add.vue?vue&type=template&id=3f7aba2c&scoped=true"
import script from "./add.vue?vue&type=script&lang=js"
export * from "./add.vue?vue&type=script&lang=js"
import style0 from "./add.vue?vue&type=style&index=0&id=3f7aba2c&scoped=true&lang=less"
import style1 from "./add.vue?vue&type=style&index=1&id=3f7aba2c&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7aba2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\code\\git\\platform_el\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f7aba2c')) {
      api.createRecord('3f7aba2c', component.options)
    } else {
      api.reload('3f7aba2c', component.options)
    }
    module.hot.accept("./add.vue?vue&type=template&id=3f7aba2c&scoped=true", function () {
      api.rerender('3f7aba2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sportCenter/member/add.vue"
export default component.exports